import React, { useMemo } from 'react';
import Chart from './Chart';
import { STRINGS } from '../utils/constants';
import { buildTrendChartOptions, buildTrendChartSeries } from '../utils/chartOptions';

const TrendChart = ({ data, isDarkMode }) => {
  const options = useMemo(() => buildTrendChartOptions({ data, isDarkMode }), [data, isDarkMode]);
  const series = useMemo(() => buildTrendChartSeries({ data }), [data]);

  return (
    <div className="glass-card chart-card">
      <div className="card-title-bar">
        <h3>{STRINGS.trendChartTitle}</h3>
      </div>
      <div style={{ minHeight: '320px' }}>
        <Chart options={options} series={series} type="area" height={320} />
      </div>
    </div>
  );
};

export default TrendChart;
